import AverageWeekSales from './AverageWeekSales'
export default AverageWeekSales
